var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M4.97854 3.19742C5.17382 3.36478 5.17382 3.63656 4.97854 3.80392L1.97913 6.37448C1.78386 6.54184 1.46673 6.54184 1.27146 6.37448C1.07618 6.20713 1.07618 5.93535 1.27146 5.76799L3.91781 3.5L1.27302 1.23201C1.07774 1.06465 1.07774 0.792871 1.27302 0.625516C1.46829 0.458161 1.78542 0.458161 1.98069 0.625516L4.98011 3.19608L4.97854 3.19742Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexticon);
export default __webpack_public_path__ + "static/media/nexticon.e8823bba9c6da19ddb1eee9ddd5bf8bb.svg";
export { ForwardRef as ReactComponent };